import {Set as ImmutableSet} from 'immutable';

/**
 * @file
 * Base implementation for stash values that are unordered sets of strings (or other values).
 */

/*
 * Runtime types.
 */

export {makeImmutableSetType as makeSetValueType} from '../../types/setType';

/*
 * Constants.
 */

export const emptySetValue = ImmutableSet<never>();

/*
 * Conflict resolution.
 */

export function mergeSetValue<T>(left: ImmutableSet<T>, right: ImmutableSet<T>): ImmutableSet<T> {
  return left.union(right);
}
